import { type FC, useState } from "react";
import { Stack } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { FilterProvider } from "@/partner/shared/components/Filter";
import { ENTRYPOINT_TABS, type StreamEntrypointTab } from "../model";
import { StreamEntrypointsFilter } from "./StreamEntrypointsFilter";
import { StreamEntrypointsList } from "./StreamEntrypointsList";
import { CreateStreamEntrypointDialog } from "./CreateStreamEntrypointDialog";
import { StreamEntrypointDialog } from "./StreamEntrypointDialog";

// По образцу Streams.tsx: id и tab открытой точки живут в ?id=/?tab=,
// диалог создания в локальном стейте (мини-диалог, не участвует в
// deep-linking).
export const StreamEntrypoints: FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [createOpen, setCreateOpen] = useState(false);

  const rawTab = searchParams.get("tab");
  // Неизвестное/пустое значение tab трактуем как edit, как у Streams.tsx.
  const tab: StreamEntrypointTab = ENTRYPOINT_TABS.includes(
    rawTab as StreamEntrypointTab
  )
    ? (rawTab as StreamEntrypointTab)
    : "edit";
  const editId = searchParams.get("id");

  const handleOpen = (id: string) => {
    searchParams.set("tab", "edit");
    searchParams.set("id", id);
    setSearchParams(searchParams);
  };

  const handleClose = () => {
    searchParams.delete("tab");
    searchParams.delete("id");
    setSearchParams(searchParams);
  };

  const handleCreated = (id: string) => {
    setCreateOpen(false);
    handleOpen(id);
  };

  return (
    <FilterProvider>
      <Stack spacing={1}>
        <StreamEntrypointsFilter onCreate={() => setCreateOpen(true)} />
        <StreamEntrypointsList onClickItem={handleOpen} />
      </Stack>

      <CreateStreamEntrypointDialog
        open={createOpen}
        onClose={() => setCreateOpen(false)}
        onCreated={handleCreated}
      />

      <StreamEntrypointDialog
        open={Boolean(editId)}
        id={editId}
        tab={tab}
        onClose={handleClose}
      />
    </FilterProvider>
  );
};
